import { useState, useEffect } from "react";
import { db } from "../firebase/config"; 

// CHANGED: Import collection instead of just collectionGroup
import { collection, collectionGroup, query, orderBy, getDocs, Timestamp } from "firebase/firestore";

export interface CancellationFeedbackItem {
  id: string;           
  uid: string;          
  subscriptionType: string;
  cancelType: string;
  q1: string | null;
  q2: string[];
  q3: string;
  submittedAt: Date;
}

export const useCancellationFeedback = () => {
  const [feedbackList, setFeedbackList] = useState<CancellationFeedbackItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  const fetchFeedback = async () => {
  try {
    setLoading(true);

    // Step 1: get all users
    const usersSnapshot = await getDocs(collection(db, "users"));

    // Step 2: for each user, check if they have cancellation history
    const allItems = await Promise.all(
      usersSnapshot.docs.map(async (userDoc) => {
        const uid = userDoc.id;

        const historySnapshot = await getDocs(
          query(
            collection(db, "cancellationFeedback", uid, "history"),
            orderBy("submittedAt", "desc")
          )
        );

        if (historySnapshot.empty) return [];

        return historySnapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            uid,
            subscriptionType: data.subscriptionType || "unknown",
            cancelType: data.cancelType || "unknown",
            q1: data.q1 || null,
            q2: data.q2 || [],
            q3: data.q3 || "",
            submittedAt: data.submittedAt?.toDate() || new Date(),
          } as CancellationFeedbackItem;
        });
      })
    );

    const flat = allItems
      .flat()
      .sort((a, b) => b.submittedAt.getTime() - a.submittedAt.getTime());

    console.log("flat:", flat.length);
    setFeedbackList(flat);
  } catch (error) {
    console.error("Error fetching cancellation feedback:", error);
  } finally {
    setLoading(false);
  }
};

  fetchFeedback();
}, []);

  return { feedbackList, loading };
};

// ... keep REASON_LABELS and formatFeedbackDate exactly the same

// Optional: Mapping labels for cleaner UI display
export const REASON_LABELS: Record<string, { title: string; subtitle: string }> = {
  no_time: { title: "Did not have enough time to explore it properly", subtitle: "Life got busy, the trial slipped by" },
  missing_features: { title: "It was missing features I need", subtitle: "Something I expected was not there" },
  too_complex: { title: "It felt too complex or hard to navigate", subtitle: "Wasn't sure where to start" },
  not_right_fit: { title: "It is not quite right for my situation", subtitle: "Not the right fit for how I train or work" },
  cost: { title: "The cost isn't worth it at this stage", subtitle: "I would need to see more value first" },
  using_else: { title: "I am already using something else", subtitle: "Going with a different platform" },
  onboarding: { title: "A clearer getting-started experience", subtitle: "More guidance in the first few days" },
  metrics: { title: "More metrics or data visualisation", subtitle: "Deeper insight into training load or readiness" },
  team_features: { title: "Better coach or team features", subtitle: "Managing multiple athletes in one place" },
  wearables: { title: "Wearable or GPS sync", subtitle: "Connect device data automatically" },
  pricing: { title: "A lower price point or flexible plan", subtitle: "Something that fits my budget" },
  just_not_for_me: { title: "Nothing, it is just not for me right now", subtitle: "" },
};

export const formatFeedbackDate = (date: Date): string => {
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};